import { ChangeDetectorRef, Component, inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Property, PropertyAvailability } from '../../../../../features/property/models/property.model';
import { AvailabilityService } from '../../../../../features/property/services/property-availability.service';
import { tap } from 'rxjs';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DialogService } from '../../../../services/dialog.service';
import { AddPropertyBookingForm } from '../add-property-booking-form/add-property-booking-form';
import { SnackBarService } from '../../../../services/snackbar.service';
import { UpdatePropertyBookingForm } from '../update-property-booking-form/update-property-booking-form';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { HapticsService } from '../../../../general/services/haptics.service';

@Component({
  selector: 'app-manage-property-calendar',
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule
  ],
  templateUrl: './manage-property-calendar.html',
  styleUrl: './manage-property-calendar.scss',
})
export class ManagePropertyCalendar implements OnInit {
  private availabilityService = inject(AvailabilityService);
  private snackbar = inject(SnackBarService);
  private haptics = inject(HapticsService);
  private cdr = inject(ChangeDetectorRef);

  property: Property | undefined = undefined;
  private readonly data = inject<Property>(MAT_DIALOG_DATA);
  private dialogService = inject(DialogService);
  private readonly dialogRef = inject(MatDialogRef<ManagePropertyCalendar, Property | null>);
  avails: PropertyAvailability[] = [];
  dataSource = new MatTableDataSource<PropertyAvailability>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  readonly initial = this.data ?? {};

  ngOnInit() {
    this.property = this.initial;
    this.loadData();
  }

  loadData = () => {
    if (this.property != undefined) {
      this.availabilityService.getPropertyAvailability(this.property.id).pipe(tap(result => {
        console.log('available', result);
        this.avails = result;
        this.cdr.detectChanges();
      })).subscribe({
        next: () => {
          this.setDataSource();
        }
      });
    }

  }
  setDataSource() {
    this.dataSource.data = this.avails;

    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }
  }

  editDate(id: number) {
    this.haptics.click();
    console.log(`edit ${id}`);
    const ref = this.dialogService.open(UpdatePropertyBookingForm,
      {
        data: id,
        width: '800px'
      }
    );

    ref.afterClosed().subscribe(() => {
      this.loadData();
    });
  }

  add() {
    this.haptics.click();
    if (this.property !== undefined) {
      console.log(`add ${this.property.id}`);

      const ref = this.dialogService.open(AddPropertyBookingForm,
        {
          data: this.property,
          width: '800px'
        }
      );

      ref.afterClosed().subscribe(() => {
        this.loadData();
      });
    }
  }

  removeDate(id: number) {
    this.haptics.click();
    console.log(`remove ${id}`);
    this.dialogService.confirm(
      'This action cannot be undone. Are you sure you want to remove this date?',
      'Remove Entry',
      'Permanently Remove',
      'Cancel'
    ).subscribe(confirmed => {
      if (confirmed) {
        console.log('confirmed, delete');
        this.availabilityService.deletePropertyAvailability(id).subscribe({
          next: () => {
            this.haptics.click();
            console.log(`deleted ${id}`);
            this.snackbar.open('Deleted successfully', ' ', {
              duration: 5000,
              panelClass: ['success-snackbar'],
              horizontalPosition: 'center',
              verticalPosition: 'top'
            });
            this.loadData();
          },
          error: err => {
            this.haptics.click();
            console.error(`Failed to delete ${id}`, err);
            this.snackbar.open('There was problem deleting the date. Please try again.', ' ', {
              duration: 5000,
              panelClass: ['error-snackbar'],
              horizontalPosition: 'center',
              verticalPosition: 'top'
            });
          }
        });
      }
    });
  }
}
